module.exports = __webpack_public_path__ + "img/ebcEn.7f058003.svg";